import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogDescription,
  DialogFooter,
  DialogHeader,
} from '@gusto/workbench';

interface EOY22TermsDialogProps {
  open: boolean;
  onClose: () => void;
}

const EOY22TermsDialog = ({ open, onClose }: EOY22TermsDialogProps) => (
  <Dialog open={open} aria-label="Terms of referral" onClose={onClose}>
    <DialogHeader heading="Terms of referral" />
    <DialogBody>
      <DialogDescription>
        <Box component="p" marginBottom={0}>
          To qualify, you must sign up for Gusto between and run one or more paid payrolls. You will
          receive a $100 Visa gift card within thirty (30) days of your first paid invoice.
          Additionally, if you qualify pursuant to these terms AND you onboard ten (10) or more
          employees prior to the first payroll run and invoice paid, the incentive offered above
          will increase to $200. You cannot participate in pay-per-click advertising on trademarked
          terms, including any derivations, variations or misspellings thereof, for search or
          content-based campaigns on Google, MSN, or Yahoo. For the purposes of these terms,
          trademarked terms include Gusto, Gusto Payroll, Gusto HR, Gusto Benefits, ZenPayroll,
          Gusto Coupon, Gusto.com and Buy Gusto (all keywords apply as broad match).
        </Box>
      </DialogDescription>
    </DialogBody>
    <DialogFooter>
      <DialogActions>
        <Button variant="primary" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </DialogFooter>
  </Dialog>
);

export default EOY22TermsDialog;
